import http from "../http";

export default (axios, base) => ({
  get: () => http.get(`${base}`),
  create: (data) => http.post(`${base}`, data),
  update: (id, data) => http.put(`${base}/${id}`, data),
  resetPassword: (id, data) => http.post(`${base}/reset_password/${id}`, data)
});
